// src/ui/MultiplayerDashboard.js - REPLACE THE ENTIRE FILE

class MultiplayerDashboard {
  constructor(scene) {
    this.scene = scene;
    this.container = null;          // The main container for the whole dashboard
    this.playerListContainer = null; // Specific container for player list items
    this.eventLogContainer = null;  // Specific container for event log items (if needed separately)
    this.eventMessages = [];
    this.visible = true;
    this.created = false;
    this.toggleBtn = null; // Reference to toggle button
    this.toggleText = null; // Reference to toggle text (+/-)
}

 // src/ui/MultiplayerDashboard.js

 create() {
  if (this.created || !this.scene || !this.scene.add) {
       console.warn("Dashboard already created or scene invalid.");
       return this.created; // Return current status
  }
  console.log("[MPDashboard] Creating UI elements...");

  try {
      const w = this.scene.cameras.main.width;
      this.container = this.scene.add.container(220, 80); // Consistent Top-left position
      this.container.setDepth(DEPTHS.DASHBOARD); // Use constant depth
      this.container.setScrollFactor(0); // Make it fixed on screen

      // --- Create Background FIRST ---
      const dashboardBg = this.scene.add.rectangle(0, 0, 320, 120, 0x000033, 0.7)
          .setOrigin(0.5, 0.5); // Center the background within the container's 0,0
      dashboardBg.setStrokeStyle(2, 0x3366FF);
      this.container.add(dashboardBg); // ADD BG TO MAIN CONTAINER

      // --- Create Title ---
      const dashboardTitle = this.scene.add.text(0, -45, "TEAM DASHBOARD", {
          fontFamily: "Arial", fontSize: "18px", fontWeight: "bold",
          color: "#FFFFFF", stroke: "#000066", strokeThickness: 2
      }).setOrigin(0.5);
      this.container.add(dashboardTitle); // ADD TITLE TO MAIN CONTAINER

      // --- Create Player List Header ---
      const playerListHeader = this.scene.add.text(-140, -20, "PLAYERS", { // Position left
          fontFamily: "Arial", fontSize: "14px", fontWeight: "bold", color: "#AAFFFF"
      }).setOrigin(0, 0.5);
      this.container.add(playerListHeader); // ADD HEADER TO MAIN CONTAINER

       // --- Create Event Log Header ---
       const eventLogHeader = this.scene.add.text(0, 25, "EVENTS", { // Position below player list area
           fontFamily: "Arial", fontSize: "14px", fontWeight: "bold", color: "#FFFFAA"
       }).setOrigin(0.5, 0); // Anchor bottom-middle of header text
       this.container.add(eventLogHeader);

      // --- Create Player List Container ---
      this.playerListContainer = this.scene.add.container(0, 5); // Position slightly below header
      this.container.add(this.playerListContainer); // ADD PLAYER LIST CONTAINER TO MAIN

       // --- Create Event Log Container ---
      this.eventLogContainer = this.scene.add.container(0, 50); // Position below event header
      this.container.add(this.eventLogContainer); // ADD EVENT LOG CONTAINER TO MAIN

      // --- Create Toggle Button (Visually on top right of header area) ---
      this.toggleBtn = this.scene.add.rectangle(140, -45, 20, 20, 0x3366FF)
          .setOrigin(0.5)
          .setInteractive({ useHandCursor: true });
      this.toggleText = this.scene.add.text(140, -45, "-", {
          fontSize: "16px", color: "#FFFFFF", fontWeight: "bold"
      }).setOrigin(0.5);

      this.toggleBtn.on('pointerdown', () => this.toggleVisibility());

      this.container.add(this.toggleBtn); // ADD TOGGLE BTN TO MAIN CONTAINER
      this.container.add(this.toggleText); // ADD TOGGLE TEXT TO MAIN CONTAINER

      this.created = true;
      console.log("[MPDashboard] Created successfully.");
      this.updatePlayerList({}, null); // Initial empty update
      this.updateEventLog();          // Initial empty update
      return true;
  } catch (error) {
       console.error("[MPDashboard] Error during create:", error);
       this.created = false;
       return false;
  }
}
 // --- UPDATE PLAYER LIST (Handles creation/positioning of player items) ---
 updatePlayerList(playersData, currentUserId) {
  if (!this.created || !this.playerListContainer || !this.playerListContainer.scene) {
       // console.warn("Dashboard not ready for player list update."); // Reduce noise
       return;
  }

  this.playerListContainer.removeAll(true); // Clear previous entries

  if (!playersData || Object.keys(playersData).length === 0) {
      const waitingText = this.scene.add.text(0, 0, "Waiting...", {
          fontFamily: "Arial", fontSize: "14px", color: "#CCCCCC"
      }).setOrigin(0.5);
      this.playerListContainer.add(waitingText); // Add directly to player list container
      return;
  }

  const playerEntries = Object.entries(playersData);
  const displayEntries = playerEntries.slice(0, 3); // Limit display to 3 for this example
  let yPos = -12; // Start Y position relative to playerListContainer's origin (adjust as needed)

  displayEntries.forEach(([playerId, playerData], index) => {
      const isCurrentUser = playerId === currentUserId;
      const entryY = yPos + 12; // Center vertically in the 24px space

      // --- Create Background FIRST ---
      const entryBg = this.scene.add.rectangle(0, entryY, 300, 24,
          isCurrentUser ? 0x336699 : (index % 2 === 0 ? 0x222244 : 0x111133),
          isCurrentUser ? 0.6 : (index % 2 === 0 ? 0.5 : 0.3)
      ).setOrigin(0.5);
      this.playerListContainer.add(entryBg); // ADD BG

      // --- Create Text Elements AFTER Background ---
      let statusColor = playerData.isAlive === false ? 0xFF0000 : (playerData.status === "hyperspace" ? 0x00FFFF : 0x00FF00);
      const statusIndicator = this.scene.add.circle(-140, entryY, 5, statusColor);

      const playerText = this.scene.add.text(-130, entryY, // Position text relative to entryY
          `${playerData.name || "Player"}${isCurrentUser ? " (You)" : ""}`, {
          fontFamily: "Arial", fontSize: "14px",
          color: isCurrentUser ? "#FFFFFF" : "#CCCCCC", fontWeight: isCurrentUser ? "bold" : "normal"
      }).setOrigin(0, 0.5);

      const scoreText = this.scene.add.text(140, entryY, // Position text relative to entryY
          `${playerData.score || 0}`, {
          fontFamily: "Arial", fontSize: "14px", color: "#FFFF00", align: "right"
      }).setOrigin(1, 0.5);

      // --- Add Text Elements ---
      this.playerListContainer.add(statusIndicator);
      this.playerListContainer.add(playerText);
      this.playerListContainer.add(scoreText);

      yPos += 25; // Increment Y for the next row
  });

  // Handle 'more players' text
   if (playerEntries.length > 3) {
       const moreY = yPos + 12;
       const moreBg = this.scene.add.rectangle(0, moreY, 300, 24, 0x222244, 0.5).setOrigin(0.5);
       const moreText = this.scene.add.text(0, moreY, `+${playerEntries.length - 3} more...`, {
            fontFamily: "Arial", fontSize: "12px", color: "#AAAAAA"
       }).setOrigin(0.5);
       this.playerListContainer.add(moreBg);
       this.playerListContainer.add(moreText);
   }
}

// --- ADD EVENT HANDLING ---
addEvent(message, color = "#FFFFFF") {
   if (!this.created) return;
   this.eventMessages.unshift({ text: message, color: color, time: Date.now() });
   const MAX_LOG_EVENTS = 3;
   if (this.eventMessages.length > MAX_LOG_EVENTS) {
       this.eventMessages.length = MAX_LOG_EVENTS; // Keep only the last 3
   }
   this.updateEventLog(); // Refresh the display
}

// --- UPDATE EVENT LOG DISPLAY ---
updateEventLog() {
   if (!this.created || !this.eventLogContainer || !this.eventLogContainer.scene) return;

   this.eventLogContainer.removeAll(true); // Clear previous log entries

   let yPos = 0; // Start Y relative to eventLogContainer's origin

   this.eventMessages.forEach((event, index) => {
       const logY = yPos + 10; // Center vertically
       const logBg = this.scene.add.rectangle(0, logY, 300, 20,
           index % 2 === 0 ? 0x333311 : 0x444422, // Alternating slightly different colors
           0.4
       ).setOrigin(0.5);
       const logText = this.scene.add.text(-140, logY, // Left align text
           event.text.length > 40 ? event.text.substring(0, 37) + '...' : event.text, // Truncate long messages
           { fontFamily: "Arial", fontSize: "12px", color: event.color }
       ).setOrigin(0, 0.5);

       this.eventLogContainer.add(logBg);
       this.eventLogContainer.add(logText);
       yPos += 22; // Increment Y for next log entry
   });
}
// --- END EVENT HANDLING ---

toggleVisibility() {
  if (!this.created || !this.container) return;
  this.visible = !this.visible;

  // Toggle visibility of content elements (Player list, Event log, Headers except Title)
  // Assuming children are added in order: BG, Title, PlayerHeader, PlayerContainer, EventHeader, EventContainer, ToggleBtn, ToggleText
  const startIndex = 2; // Index of PlayerHeader
  const endIndex = this.container.list.length - 3; // Index before ToggleBtn

  for (let i = startIndex; i <= endIndex; i++) {
       if (this.container.list[i]) this.container.list[i].setVisible(this.visible);
  }

  // Resize background and update toggle button text
  const bg = this.container.list[0]; // Background is the first element
  if (bg) {
      bg.displayHeight = this.visible ? 120 : 40; // Adjust height
      // Optionally tween the height change
       this.scene.tweens?.add({ targets: bg, displayHeight: this.visible ? 120 : 40, duration: 150, ease: 'Sine.easeInOut' });
  }
  if (this.toggleText) this.toggleText.setText(this.visible ? "-" : "+");
}

// Keep setVisible, updatePosition, destroy as before...
setVisible(visible) {
   if (this.container) this.container.setVisible(visible);
}

updatePosition() {
   if (this.container) this.container.setPosition(220, 80); // Keep consistent position
}

destroy() {
   if (this.container) {
       try { this.container.destroy(true); } catch (e) {} // Destroy container and children
       this.container = null;
   }
   this.playerListContainer = null;
   this.eventLogContainer = null;
   this.created = false;
   this.visible = false;
   this.eventMessages = [];
   console.log("[MPDashboard] Destroyed.");
}
}

// Define the DEPTHS constant if it's not imported
const DEPTHS = DEPTHS || {
BACKGROUND: -10,
GHOST_SHIPS: 5,
GAME_OBJECTS: 10,
PLAYER: 50,
TRAILS: 45,
BASE_UI: 950,
DASHBOARD: 900, // Ensure this is defined
FLOATING_NOTIFICATIONS: 1000,
OVERLAYS: 5000,
};

export default MultiplayerDashboard;